import { useState } from "react";
import { Wrapper } from "./Swap.style";
import { Com1 } from "./components/Com1/Com1";
import { Com2 } from "./components/Com2/Com2";
import { SketchWalletPay } from "./components/SketchWalletPay/SketchWalletPay";
import { useMediaQuery } from "react-responsive";
import { SketchWalletPayMobile } from "./components/SketchWalletPay/SketchWalletPayMobile";
import { ExclusiveWallet } from "./components/ExclusiveWallet/ExclusiveWallet";
import { Bottom } from "./components/Bottom/Bottom";

export const Swap = () => {
  const [selected, setSelected] = useState(1);
  const isPc = useMediaQuery({
    query: "(min-width:900px)",
  });

  return (
    <Wrapper>
      <Com1 />
      <Com2 selected={selected} setSelected={setSelected} />
      {selected === 1 ? isPc ? <SketchWalletPay /> : <SketchWalletPayMobile /> : <ExclusiveWallet />}
      {selected === 1 ? <Bottom /> : ""}
    </Wrapper>
  );
};
